"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overview = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const bureau_logo_1 = __importDefault(require("../../components/bureau-logo"));
const components_1 = require("../../components");
const basic_score_display_1 = __importDefault(require("../basic-score-display"));
const what_score_means_1 = __importDefault(require("../../content/what-score-means"));
const card_with_rows_1 = require("../card-with-rows");
const base_react_components_1 = require("@navinc/base-react-components");
const bureaus_1 = require("../../utils/bureaus");
const __1 = require("../..");
const utils_1 = require("@navinc/utils");
const StyledSection = styled_components_1.default.div.withConfig({ displayName: "reports-StyledSection", componentId: "reports-10eu4dp" }) `
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  gap: 10px;
`;
const Overview = ({ bureau = 'dnb', error, isLoading, report, type = 'business', isDirect = false, businessMatchLink, whatScoreMeansChildren, businessAddresses, children, }) => {
    var _a, _b, _c;
    const _d = report.score || {}, { label } = _d, basicScoreDisplayReport = __rest(_d, ["label"]);
    const { business, score, reportableType } = basicScoreDisplayReport || {};
    const resolvedType = reportableType !== null && reportableType !== void 0 ? reportableType : type;
    const bureauObject = (0, bureaus_1.getBureau)(bureau);
    const bureauSlug = bureauObject === null || bureauObject === void 0 ? void 0 : bureauObject.slug;
    const scoringModel = (0, __1.getScoringModel)(bureauObject, resolvedType);
    const bureauDisplayNameWithType = (_a = scoringModel === null || scoringModel === void 0 ? void 0 : scoringModel.displayNameWithType) !== null && _a !== void 0 ? _a : 'unknown';
    const whyScoreDifferentLink = !!(scoringModel === null || scoringModel === void 0 ? void 0 : scoringModel.scoreDifferentUrl) && (react_1.default.createElement(base_react_components_1.Button, { variation: "buttonLink", href: scoringModel.scoreDifferentUrl, target: "_blank", rel: "noopener noreferrer" }, "Why is my score different?"));
    return (react_1.default.createElement(card_with_rows_1.CardWithRows, { "data-testid": `basic-${bureauSlug}-report:overview:header` },
        react_1.default.createElement(card_with_rows_1.CardWithRows.Body, null,
            react_1.default.createElement(bureau_logo_1.default, { bureau: bureauSlug, "data-testid": `${bureauSlug}-report:overview:header-logo`, label: label })),
        react_1.default.createElement(card_with_rows_1.CardWithRows.Subheader, { "data-testid": `basic-${bureauSlug}-report:overview:score-grid` },
            react_1.default.createElement("div", null,
                !!((_b = report === null || report === void 0 ? void 0 : report.score) === null || _b === void 0 ? void 0 : _b.reportDate) && (react_1.default.createElement(base_react_components_1.Copy, { size: "sm" },
                    "Report date: ",
                    (0, utils_1.safeDateString)((_c = report === null || report === void 0 ? void 0 : report.score) === null || _c === void 0 ? void 0 : _c.reportDate))),
                react_1.default.createElement(basic_score_display_1.default, { bureau: bureauSlug, error: error, isLoading: isLoading, report: report.score, isDirect: isDirect })),
            resolvedType.toLowerCase() === 'business' ? (react_1.default.createElement(components_1.NotMyBusiness, { businessAddress: businessAddresses !== null && businessAddresses !== void 0 ? businessAddresses : business, link: businessMatchLink !== null && businessMatchLink !== void 0 ? businessMatchLink : (isDirect ? `/business-search-${bureau}` : `/partner/business-match/${bureauSlug}`), title: `${bureauDisplayNameWithType} Record shown for:`, copy: whyScoreDifferentLink })) : (react_1.default.createElement(StyledSection, null,
                children,
                whyScoreDifferentLink))),
        react_1.default.createElement(card_with_rows_1.CardWithRows.Body, null,
            react_1.default.createElement(what_score_means_1.default, { bureau: bureau, score: score, type: resolvedType }, whatScoreMeansChildren))));
};
exports.Overview = Overview;
exports.default = exports.Overview;
//# sourceMappingURL=index.js.map